module.exports = __webpack_public_path__ + "img/operationCenter.935cbbf9.png";